<template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-2 bg-white rounded p-4">
        <div>
            <h5 class="text-lg font-semibold text-gray-700">
                Profile Information
            </h5>
            <p class="text-gray-600">
                Update your account's profile information and email address.
            </p>
        </div>
        <div class="my-3 shadow rounded grid grid-cols-4 gap-4 p-5">
            <div class="col-span-4">
                <!-- Profile Photo File Input -->
                <input
                    type="file"
                    class="hidden"
                    ref="photo"
                    accept="image/*"
                    @change="updatePhotoPreview"
                />
                <label
                    for="type"
                    class="block text-sm font-medium text-gray-700"
                    >Photo</label
                >
                <!-- Current Profile Photo -->
                <div class="mt-2" v-show="!photoPreview">
                    <img
                        :src="user.profile_photo_url"
                        alt="Current Profile Photo"
                        class="rounded-full h-20 w-20 object-cover"
                    />
                </div>

                <!-- New Profile Photo Preview -->
                <div class="mt-2" v-show="photoPreview">
                    <span
                        class="block rounded-full w-20 h-20"
                        :style="
                            'background-size: cover; background-repeat: no-repeat; background-position: center center; background-image: url(\'' +
                            photoPreview +
                            '\');'
                        "
                    >
                    </span>
                </div>

                <button
                    class="
                        inline-flex
                        items-center
                        px-4
                        py-2
                        bg-white
                        border border-gray-300
                        rounded-md
                        font-semibold
                        text-xs text-gray-700
                        uppercase
                        tracking-widest
                        shadow-sm
                        hover:text-gray-500
                        focus:outline-none
                        focus:border-blue-300
                        focus:shadow-outline-blue
                        active:text-gray-800 active:bg-gray-50
                        transition
                        ease-in-out
                        duration-150
                        mt-2
                        mr-2
                    "
                    type="button"
                    @click.prevent="selectNewPhoto"
                >
                    Select A New Photo
                </button>

                <button
                    type="button"
                    class="
                        inline-flex
                        items-center
                        px-4
                        py-2
                        bg-red-500
                        rounded-md
                        font-semibold
                        text-xs text-white
                        uppercase
                        tracking-widest
                        shadow-sm
                        focus:outline-none
                        transition
                        ease-in-out
                        duration-150
                        mt-2
                        mr-2
                    "
                    @click.prevent="deletePhoto"
                    v-if="user.profile_photo_path"
                >
                    Remove Photo
                </button>
                <p v-if="form.hasErrors" class="text-sm text-red-600">
                    {{ form.errors.updateProfileInformation.photo }}
                </p>
            </div>
            <div class="col-span-4">
                <label
                    for="first_name"
                    class="block text-sm font-medium text-gray-700"
                    >First Name</label
                >
                <input
                    v-model="form.first_name"
                    type="text"
                    name="first_name"
                    id="first_name"
                    autocomplete="name"
                    class="
                        mt-1
                        focus:ring-indigo-500 focus:border-indigo-500
                        block
                        w-full
                        shadow-sm
                        sm:text-sm
                        border-gray-300
                        rounded-md
                    "
                />
                <p v-if="form.hasErrors" class="text-sm text-red-600">
                    {{ form.errors.updateProfileInformation.first_name }}
                </p>
            </div>
            <div class="col-span-4">
                <label
                    for="last_name"
                    class="block text-sm font-medium text-gray-700"
                    >Last Name</label
                >
                <input
                    v-model="form.last_name"
                    type="text"
                    name="last_name"
                    id="last_name"
                    autocomplete="name"
                    class="
                        mt-1
                        focus:ring-indigo-500 focus:border-indigo-500
                        block
                        w-full
                        shadow-sm
                        sm:text-sm
                        border-gray-300
                        rounded-md
                    "
                />
                <p v-if="form.hasErrors" class="text-sm text-red-600">
                    {{ form.errors.updateProfileInformation.last_name }}
                </p>
            </div>
            <div class="col-span-4">
                <label
                    for="email"
                    class="block text-sm font-medium text-gray-700"
                    >Email</label
                >
                <input
                    v-model="form.email"
                    type="email"
                    name="email"
                    id="email"
                    autocomplete="name"
                    class="
                        mt-1
                        focus:ring-indigo-500 focus:border-indigo-500
                        block
                        w-full
                        shadow-sm
                        sm:text-sm
                        border-gray-300
                        rounded-md
                    "
                />
                <p v-if="form.hasErrors" class="text-sm text-red-600">
                    {{ form.errors.updateProfileInformation.email }}
                </p>
            </div>
            <div class="col-span-4 flex justify-end">
                <button
                    @click="updateProfileInformation"
                    class="
                        inline-flex
                        items-center
                        px-4
                        py-2
                        bg-gray-800
                        border border-transparent
                        rounded-md
                        font-semibold
                        text-xs text-white
                        uppercase
                        tracking-widest
                        hover:bg-gray-700
                        active:bg-gray-900
                        focus:outline-none
                        focus:border-gray-900
                        focus:shadow-outline-gray
                        transition
                        ease-in-out
                        duration-150
                    "
                >
                    Save
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: this.$inertia.form(
                {
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    email: this.user.email,
                    photo: null,
                },
                {
                    bag: "updateProfileInformation",
                    resetOnSuccess: false,
                    forceFormData: true,
                }
            ),
            photoPreview: null,
        };
    },
    props: {
        user: Object,
    },
    methods: {
        updateProfileInformation() {
            if (this.$refs.photo) {
                this.form.photo = this.$refs.photo.files[0];
            }

            this.form.post(route("admin.user.profile.update"), {
                preserveScroll: true,
            });
        },

        selectNewPhoto() {
            this.$refs.photo.click();
        },

        updatePhotoPreview() {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.photoPreview = e.target.result;
            };

            reader.readAsDataURL(this.$refs.photo.files[0]);
        },

        deletePhoto() {
            this.$inertia
                .delete(route("admin.user.profile.destroy"), {
                    preserveScroll: true,
                })
                .then(() => {
                    this.photoPreview = null;
                });
        },
    },
};
</script>
